import { productGroupsConfig as contestProductGroupsConfig } from './contest';
import { productGroupsConfig as fixedPriceProjectProductGroupsConfig } from './fixed-price-project';
import type { ProductGroupConfig, ProductGroupKey } from '../../types';

export function isValidProductGroupKey(productGroupKey: string): boolean {
    return !!getProductGroupsConfigByKey(productGroupKey as ProductGroupKey);
}

export function getProductGroupConfigByKey(productGroupKey: ProductGroupKey): ProductGroupConfig {
    return getProductGroupsConfigByKey(productGroupKey);
}

export function getProductGroupsConfigByKey(productGroupKey: ProductGroupKey): ProductGroupConfig {
    const productGroupsConfig: Record<ProductGroupKey, ProductGroupConfig> = {
        ...contestProductGroupsConfig,
        ...fixedPriceProjectProductGroupsConfig,
    };
    return productGroupsConfig[productGroupKey];
}
